import React, { useEffect, useContext, useReducer, useState } from 'react';
import { store as reportsStore } from '../reducer';
import { makeStyles } from '@material-ui/core/styles';
import Filters from './Filters';
import List from './List';
import useTitle from 'hooks/useTitle';
import Total from 'components/Total/Total';
import { QueryCache, useQuery, useQueryClient } from 'react-query';
import { rond } from 'fns';
import { toEN } from 'fns';
import { formatNumber } from 'fns';
import { toFA } from 'fns/toFA';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const Deposits = () => {
  useTitle('گزارش واریزی ها');
  const classes = useStyles();

  const { data } = useQuery(['commissionReports', window.location.search]);

  const { dispatch: reportsDispatch } = useContext(reportsStore);

  useEffect(() => {
    reportsDispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: 'گزارش واریزی ها',
        category: 'جهت گزارش و ثبت واریزی های انجام شده',
      },
    });
  }, []);

  return (
    <div className={classes.root}>
      <Filters />
      <List />
      <div
        className="d-flex"
        style={{ gap: 10, position: 'sticky', bottom: 0 }}
      >
        <Total
          title={'جمع کل شرکت: '}
          backgroundColor={'purple'}
          total={toFA(
            formatNumber(toEN(rond(data?.data.totalFootabCommissions)))
          )}
        />
        <Total
          total={toFA(
            formatNumber(toEN(rond(data?.data.totalUserCommissions)))
          )}
          title={'جمع کل متعلقه: '}
          backgroundColor={'yellow'}
        />
      </div>
    </div>
  );
};

export default React.memo(Deposits);
